import { Helmet } from "react-helmet-async";

var SITE_NAME = "Resurrected Gun Parts";
var SITE_URL = "https://resurrectedgunparts.com";
var DEFAULT_IMAGE = SITE_URL + "/og-image.png";
var DEFAULT_DESC = "Reproduction parts for vintage military firearms. Arisaka, Maxim, MP-35 Bergmann, PKM, AK, and more. Rebuild. Restore. Resurrect.";

/**
 * Reusable SEO head injector. Use on every public page.
 *
 *   <Seo
 *     title="Type 99 Arisaka Bolt"        // becomes "Type 99 Arisaka Bolt — Resurrected Gun Parts"
 *     description="Quality reproduction…"
 *     path="/shop/abc123"
 *     image="https://.../product.jpg"      // optional, falls back to default OG image
 *     jsonLd={{...}}                       // optional Schema.org payload
 *     noIndex={false}                      // pass true to hide from search engines
 *   />
 */
export default function Seo(props) {
  var fullTitle = props.title
    ? props.title + " — " + SITE_NAME
    : SITE_NAME + " — Reproduction Parts for Vintage Military Firearms";
  var description = (props.description || DEFAULT_DESC).substring(0, 300);
  var url = SITE_URL + (props.path || "/");
  var image = props.image || DEFAULT_IMAGE;
  var type = props.type || "website";
  var noIndex = !!props.noIndex;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={SITE_NAME} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Optional JSON-LD structured data */}
      {props.jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(props.jsonLd)}
        </script>
      )}
    </Helmet>
  );
}
